import React from "react";

const SimilarExercises = () => {
    return <div></div>;
};

export default SimilarExercises;
